export interface IVehiclesDto {
    id: string;
    name: string;
    licensePlate?: string;
}

export interface IDriversDto {
    id: string;

    name: string;
}

export interface ICarrierVehiclesDriversDto {
    id: string;
    name: string;
    vehicles?: IVehiclesDto[];
    drivers?: IDriversDto[];
}
